import { Delete } from "@mui/icons-material";
import { Button, SxProps, Theme } from "@mui/material";

import GaiaConfirmActionDialog from "~/modules/app/components/GaiaConfirmActionDialog";
import useDestructiveActionBlocker from "~/modules/app/hooks/useDestructiveActionBlocker";

type Props = {
    disabled?: boolean;
    label?: string;
    description?: string;
    isLoading: boolean;
    sx?: SxProps<Theme>;
    onDelete: () => Promise<unknown>;
};

export default function GaiaDeleteButton({ disabled, label, description, isLoading, onDelete, sx }: Props) {
    const deleteBlocker = useDestructiveActionBlocker(onDelete);

    return (
        <>
            <GaiaConfirmActionDialog description={description} blocker={deleteBlocker} />
            <Button color="error" disabled={disabled} size="small" loading={isLoading} onClick={deleteBlocker.onAction} sx={sx}>
                <Delete />
                {label}
            </Button>
        </>
    );
}
